import React from "react";
import HairColorStreaksLandingHeadImg from "./HairColorStreaksLandingHeadImg";

const HairColorStreaksLandingHead = () => {
  return (
    <div className="hairTreatmentLandingHead">
      <HairColorStreaksLandingHeadImg />
    </div>
  );
};

export default HairColorStreaksLandingHead;
